import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AndroidMediaPlayerOpen {
    isOpen: boolean;
}
const initialState: AndroidMediaPlayerOpen = {
    isOpen: true,
};
const AndroidMediaPlayer = createSlice({
    name: 'androidMediaPlayerOpen',
    initialState,
    reducers: {
        setAndroidMediaPlayerOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setAndroidMediaPlayerOpen } = AndroidMediaPlayer.actions;
export default AndroidMediaPlayer.reducer;
